import React from 'react'
import PropTypes from 'prop-types'

import BusinessSection from '@/business-section'
import Input from '@/input'
import Textarea from '@/textarea'
import Button from '@/button'

import './styles.css'

const SectionContactForm = ({ justEmail }) => {
  if (justEmail) {
    return (
      <form
        name="contact"
        action="https://formspree.io/jari@choicely.com"
        method="POST"
        className="flex items-center justify-center mb0"
      >
        <Input
          placeholder="Enter your email"
          type="email"
          name="email"
          required
        />
        <Button type="submit" color="green" className="ml1">
          Send
        </Button>
      </form>
    )
  }

  return (
    <BusinessSection
      title="Talk to us!"
      subtitle="Need some help? Interested in partnerships? We would love to help you. "
    >
      <form
        className="mw330 flex flex-column center mb0"
        name="contact"
        action="https://formspree.io/jari@choicely.com"
        method="POST"
      >
        <Input label="Name" type="text" name="name" required />

        <Input label="E-mail Adress" type="email" name="email" required />

        <Textarea label="Message" name="message" rows="7" required />

        <Button type="submit" color="blue">
          Send Message
        </Button>
      </form>
    </BusinessSection>
  )
}

SectionContactForm.propTypes = {
  justEmail: PropTypes.bool
}

export default SectionContactForm



// WEBPACK FOOTER //
// ./src/components/section-contact-form/section-contact-form.js